import { ColumnSort, SortingState, Updater } from '@tanstack/react-table';

import { callOrReturn } from '@adsk/alloy-react-helpers';

export const useSorting = (
  sorting: ColumnSort[],
  onSortingChange?: (sorting: ColumnSort[]) => void,
) => {
  return {
    sortingState: { sorting },
    sortingOptions: {
      manualSorting: true,
      enableSorting: true,
      enableSortingRemoval: false,
      disableSortRemove: true,
      onSortingChange: (updaterOrValue: Updater<SortingState>) => {
        const newState = callOrReturn<Updater<SortingState>>(
          updaterOrValue,
          sorting,
        );
        onSortingChange?.(newState);
        return newState;
      },
    },
  };
};
